<div class="readonlytbox milestone-panel">
  @if (showDesignation) {
    <div class="rtnav ui-g">
      <div class="ui-g-6 msgbox-6">
        @for (message of msgsMilestone2Details; track message) {
          <p-message [life]="3000" [text]="message.detail"></p-message>
        }
      </div>
      @if (!paymentMilestone2DesignationbtnNav) {
        <div class="ui-g-5"></div>
      }
      @if (paymentMilestone2DesignationbtnNav) {
        <div class="ui-g-5">
          <button
            type="button"
            pButton
            (click)="editMilestone2DesignationCancel()"
            class="ui-button-secondary flat fl-rt">
            Cancel
          </button>
          <button
            type="submit"
            pButton
            (click)="onSubmitMilestone2Designation()"
            class="flat btnmr fl-rt">
            Save
          </button>
        </div>
      }
      @if (!preventM2DesignationEdit) {
        <div class="ui-g-1 edit-history-icon">
          <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
          <button
            class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
            pTooltip="Edit"
            (click)="editSpecialInvestmentMilestone2Designation()"
            tooltipPosition="bottom"
            [disabled]="isOptOutPartner || isPartnerBlocked"></button>
        </div>
      }
    </div>
  }
  @if (showDesignation) {
    <div class="ui-g designation-section pl-2 pr-4">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 Designation</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4 dropdown">
        <p-select
          appendTo="body"
          [options]="milestone2Designations"
          [(ngModel)]="selectedDesignation"
          [readonly]="isReadonlyMilestone2Details"
          [class.readonlydd]="isReadonlyMilestone2Details === true"
          [disabled]="isReadonlyMilestone2Details"
          placeholder="--SELECT--"
          optionLabel="designationName"></p-select>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
  }
  @if (hasMilestoneData && hasVaildPayoutMetric) {
    <div class="milestone2-tabs">
      @if (programTypeId === ProgramType.MSSP) {
        <p-tabs scrollable value="0">
          <p-tablist>
            @if (showM365SecuritySales && hasM365SecuritySales) {
              <p-tab value="0">M365 Security Sales</p-tab>
            }
            @if (showSecurityACR && hasSecurityACR) {
              <p-tab value="1">Security ACR</p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              <form [formGroup]="formSecuritySales">
                <div class="rtnav ui-g">
                  <div class="ui-g-6 msgbox-6">
                    @for (
                      message of msgsMilestone2InvoiceDetails;
                      track message
                    ) {
                      <p-message
                        [life]="3000"
                        [text]="message.detail"></p-message>
                    }
                  </div>
                  @if (!paymentMilestone2btnNav) {
                    <div class="ui-g-5"></div>
                  }
                  @if (paymentMilestone2btnNav) {
                    <div class="ui-g-5">
                      <button
                        type="button"
                        pButton
                        (click)="editMilestone2PaymentCancel(formSecuritySales)"
                        class="ui-button-secondary flat fl-rt">
                        Cancel
                      </button>
                      <button
                        type="submit"
                        pButton
                        (click)="
                          onSubmitMilestone2PaymentInvoice(formSecuritySales)
                        "
                        class="flat btnmr fl-rt">
                        Save
                      </button>
                    </div>
                  }
                  <div class="ui-g-1 edit-history-icon">
                    <button
                      class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
                      pTooltip="Edit"
                      (click)="editSpecialInvestmentMilestone2Payment()"
                      tooltipPosition="bottom"
                      [disabled]="isOptOutPartner || isPartnerBlocked">
                      Edit
                    </button>
                  </div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 1</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier1PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier1PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 2</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier2PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier2PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 3</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier3PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier3PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
                <div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="hdbl">Tier 4</div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Engagement Type
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="payoutMetric" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Payment Amount
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4PaymentAmount" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Date Tier Met
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4MetDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Paid Date
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-datepicker
                        appendTo="body"
                        formControlName="tier4PaidDate"
                        placeholder="mm/dd/yy"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyMilestone2Payment === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="
                          isReadonlyMilestone2Payment === true
                        "
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4PaymentDocumentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4InvoiceNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Central Transaction ID
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4PaymentCentralTransactionId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-select
                        appendTo="body"
                        [options]="paymentStatus"
                        [readonly]="isReadonlyMilestone2Payment"
                        [class.readonlydd]="
                          isReadonlyMilestone2Payment === true
                        "
                        formControlName="tier4PaymentStatus"
                        placeholder="--SELECT--"
                        optionLabel="paymentStatusName"></p-select>
                    </div>
                  </div>
                </div>
              </form>
            </p-tabpanel>
            <p-tabpanel value="1">
              <form [formGroup]="formSecurityACR">
                <div class="rtnav ui-g">
                  <div class="ui-g-6 msgbox-6">
                    @for (
                      message of msgsMilestone2InvoiceDetails;
                      track message
                    ) {
                      <p-message
                        [life]="3000"
                        [text]="message.detail"></p-message>
                    }
                  </div>
                  @if (!paymentMilestone2btnNav) {
                    <div class="ui-g-5"></div>
                  }
                  @if (paymentMilestone2btnNav) {
                    <div class="ui-g-5">
                      <button
                        type="button"
                        pButton
                        (click)="editMilestone2PaymentCancel(formSecurityACR)"
                        class="ui-button-secondary flat fl-rt">
                        Cancel
                      </button>
                      <button
                        type="submit"
                        pButton
                        (click)="
                          onSubmitMilestone2PaymentInvoice(formSecurityACR)
                        "
                        class="flat btnmr fl-rt">
                        Save
                      </button>
                    </div>
                  }
                  <div class="ui-g-1 edit-history-icon">
                    <button
                      class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
                      pTooltip="Edit"
                      (click)="editSpecialInvestmentMilestone2Payment()"
                      tooltipPosition="bottom"
                      [disabled]="isOptOutPartner || isPartnerBlocked">
                      Edit
                    </button>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 1</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier1PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier1PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 2</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier2PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier2PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 3</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier3PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier3PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>

                <div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="hdbl">Tier 4</div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Engagement Type
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="payoutMetric" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Payment Amount
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4PaymentAmount" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Date Tier Mettt
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4MetDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Paid Date
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-datepicker
                        appendTo="body"
                        formControlName="tier4PaidDate"
                        placeholder="mm/dd/yy"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyMilestone2Payment === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="
                          isReadonlyMilestone2Payment === true
                        "
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4PaymentDocumentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4InvoiceNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Central Transaction ID
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4PaymentCentralTransactionId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-select
                        appendTo="body"
                        [options]="paymentStatus"
                        [readonly]="isReadonlyMilestone2Payment"
                        [class.readonlydd]="
                          isReadonlyMilestone2Payment === true
                        "
                        formControlName="tier4PaymentStatus"
                        placeholder="--SELECT--"
                        optionLabel="paymentStatusName"></p-select>
                    </div>
                  </div>
                </div>
              </form>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      }

      @if (
        programTypeId === ProgramType.Operator &&
        (formEnabledEngagement || formEnabledEngagement)
      ) {
        <p-tabs scrollable [value]="selectedTab">
          <p-tablist>
            @if (showSalesEngagement) {
              <p-tab [value]="0">Sales Engagement</p-tab>
            }
            @if (showEnabledEngagement) {
              <p-tab [value]="1">Enabled Engagement</p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel [value]="0">
              <form [formGroup]="formSalesEngagement">
                <div class="rtnav ui-g">
                  <div class="ui-g-6 msgbox-6">
                    @for (
                      message of msgsMilestone2InvoiceDetails;
                      track message
                    ) {
                      <p-message
                        [life]="3000"
                        [text]="message.detail"></p-message>
                    }
                  </div>
                  @if (!paymentMilestone2btnNav) {
                    <div class="ui-g-5"></div>
                  }
                  @if (paymentMilestone2btnNav) {
                    <div class="ui-g-5">
                      <button
                        type="button"
                        pButton
                        (click)="
                          editMilestone2PaymentCancel(formSalesEngagement)
                        "
                        class="ui-button-secondary flat fl-rt">
                        Cancel
                      </button>
                      <button
                        type="submit"
                        pButton
                        (click)="
                          onSubmitMilestone2PaymentInvoice(formSalesEngagement)
                        "
                        class="flat btnmr fl-rt">
                        Save
                      </button>
                    </div>
                  }
                  <div class="ui-g-1 edit-history-icon">
                    <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
                    <button
                      class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
                      pTooltip="Edit"
                      (click)="editSpecialInvestmentMilestone2Payment()"
                      tooltipPosition="bottom"
                      [disabled]="isOptOutPartner || isPartnerBlocked"></button>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 1</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tenantId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Is Accelerated Payment
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="isAcceleratedPayment" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier1PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1MaturityDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1MaturityStatus" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier1PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 2</div>
                  </div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tenantId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Is Accelerated Payment
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="isAcceleratedPayment" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier2PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2MaturityDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2MaturityStatus" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier2PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 3</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tenantId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Is Accelerated Payment
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="isAcceleratedPayment" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier3PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3MaturityDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3MaturityStatus" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier3PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>
                <div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="hdbl">Tier 4</div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tenantId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Is Accelerated Payment
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="isAcceleratedPayment" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Payment Amount
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4PaymentAmount" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Date Tier Met
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4MetDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Paid Date
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-datepicker
                        appendTo="body"
                        formControlName="tier4PaidDate"
                        placeholder="mm/dd/yy"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyMilestone2Payment === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="
                          isReadonlyMilestone2Payment === true
                        "
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4MaturityDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4MaturityStatus" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4PaymentDocumentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4InvoiceNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Central Transaction ID
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4PaymentCentralTransactionId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-select
                        appendTo="body"
                        [options]="paymentStatus"
                        [readonly]="isReadonlyMilestone2Payment"
                        [class.readonlydd]="
                          isReadonlyMilestone2Payment === true
                        "
                        formControlName="tier4PaymentStatus"
                        placeholder="--SELECT--"
                        optionLabel="paymentStatusName"></p-select>
                    </div>
                  </div>
                </div>
              </form>
            </p-tabpanel>
            <p-tabpanel [value]="1">
              <form [formGroup]="formEnabledEngagement">
                <div class="rtnav ui-g">
                  <div class="ui-g-6 msgbox-6">
                    @for (
                      message of msgsMilestone2InvoiceDetails;
                      track message
                    ) {
                      <p-message
                        [life]="3000"
                        [text]="message.detail"></p-message>
                    }
                  </div>
                  @if (!paymentMilestone2btnNav) {
                    <div class="ui-g-5"></div>
                  }
                  @if (paymentMilestone2btnNav) {
                    <div class="ui-g-5">
                      <button
                        type="button"
                        pButton
                        (click)="
                          editMilestone2PaymentCancel(formEnabledEngagement)
                        "
                        class="ui-button-secondary flat fl-rt">
                        Cancel
                      </button>
                      <button
                        type="submit"
                        pButton
                        (click)="
                          onSubmitMilestone2PaymentInvoice(
                            formEnabledEngagement
                          )
                        "
                        class="flat btnmr fl-rt">
                        Save
                      </button>
                    </div>
                  }
                  <div class="ui-g-1 edit-history-icon">
                    <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
                    <button
                      class="fa fa-pencil ico cpointer fl-rt milestone2-edit-button"
                      pTooltip="Edit"
                      (click)="editSpecialInvestmentMilestone2Payment()"
                      tooltipPosition="bottom"
                      [disabled]="isOptOutPartner || isPartnerBlocked"></button>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 1</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tenantId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Is Accelerated Payment
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="isAcceleratedPayment" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier1PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1MaturityDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier1MaturityStatus" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier1PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier1PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 2</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tenantId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Is Accelerated Payment
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="isAcceleratedPayment" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier2PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2MaturityDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier2MaturityStatus" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier2PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier2PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>

                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Tier 3</div>
                  </div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Engagement Type
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="payoutMetric" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tenantId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Is Accelerated Payment
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="isAcceleratedPayment" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Payment Amount
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3PaymentAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Date Tier Met
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3MetDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Milestone 2 Paid Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="tier3PaidDate"
                      placeholder="mm/dd/yy"
                      dateFormat="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyMilestone2Payment === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="
                        isReadonlyMilestone2Payment === true
                      "
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3MaturityDate" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="tier3MaturityStatus" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Document Number
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3PaymentDocumentNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3InvoiceNumber" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Payment Central Transaction ID
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlyMilestone2Payment"
                      formControlName="tier3PaymentCentralTransactionId" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-select
                      appendTo="body"
                      [options]="paymentStatus"
                      [readonly]="isReadonlyMilestone2Payment"
                      [class.readonlydd]="isReadonlyMilestone2Payment === true"
                      formControlName="tier3PaymentStatus"
                      placeholder="--SELECT--"
                      optionLabel="paymentStatusName"></p-select>
                  </div>
                </div>

                <div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <div class="hdbl">Tier 4</div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Engagement Type
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="payoutMetric" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tenantId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Is Accelerated Payment
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="isAcceleratedPayment" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Payment Amount
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4PaymentAmount" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Date Tier Met
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4MetDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Milestone 2 Paid Date
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-datepicker
                        appendTo="body"
                        formControlName="tier4PaidDate"
                        placeholder="mm/dd/yy"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyMilestone2Payment === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="
                          isReadonlyMilestone2Payment === true
                        "
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Date</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4MaturityDate" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Maturity Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="tier4MaturityStatus" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4PaymentDocumentNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Invoice</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4InvoiceNumber" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      Payment Central Transaction ID
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyMilestone2Payment"
                        formControlName="tier4PaymentCentralTransactionId" />
                    </div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">Payment Status</div>
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-select
                        appendTo="body"
                        [options]="paymentStatus"
                        [readonly]="isReadonlyMilestone2Payment"
                        [class.readonlydd]="
                          isReadonlyMilestone2Payment === true
                        "
                        formControlName="tier4PaymentStatus"
                        placeholder="--SELECT--"
                        optionLabel="paymentStatusName"></p-select>
                    </div>
                  </div>
                </div>
              </form>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      }
    </div>
  }
  @if (!hasMilestoneData || !hasVaildPayoutMetric) {
    <div>
      <h3>
        Payment Milestone 2 data (Payout Metric) not yet available for the
        activity
      </h3>
    </div>
  }
</div>
